import { onTrackEvent } from '../events/onTrackEvent';

function initOnePageStoreToSdk(pageEvent) {
  const { onCartUpdate, onGetCartFailed } = pageEvent;

  const onePageStore = {
    onCartUpdate,
    onGetCartFailed,
    onTrackEvent,
  };

  window.shopline = Object.assign(window.shopline || {}, {
    onePageStore,
  });
}
export default initOnePageStoreToSdk;
